@if (loading()) {
  <div class="loading">
    <glxy-loading-spinner [fullWidth]="true"></glxy-loading-spinner>
  </div>
} @else {
  @if (actionError(); as error) {
    <glxy-alert type="error">
      @if (error === 'limit') {
        {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.LIMIT_ERROR' | translate }}
      } @else if (error === 'delete') {
        {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.DELETE_ERROR' | translate }}
      } @else {
        {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.SAVE_ERROR' | translate }}
      }
    </glxy-alert>
  }
  @if (errored()) {
    <glxy-alert type="error">
      {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.LOAD_ERROR' | translate }}
    </glxy-alert>
  } @else if (jobs().length === 0) {
    <glxy-alert type="info">
      {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.EMPTY' | translate }}
    </glxy-alert>
  } @else {
    <div class="job-list">
      @for (row of visibleJobs(); track row.testCase.id) {
        <button type="button" class="job-card-trigger" (click)="openDetail(row)">
          <mat-card class="job-card">
            <mat-card-content>
              <div class="job-row">
                <div class="job-text">
                  <div class="job-name">
                    <span>{{ row.testCase.name }}</span>
                    @if (row.custom) {
                      <glxy-badge color="blue" size="small">
                        {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CUSTOM_BADGE' | translate }}
                      </glxy-badge>
                    }
                  </div>
                  <div class="job-scenario">{{ row.testCase.scenario }}</div>
                </div>
                @if (row.successRate === null) {
                  <glxy-badge class="job-standing" color="grey" size="small">
                    {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.NO_RESULTS' | translate }}
                  </glxy-badge>
                } @else {
                  @let onTarget = standing(row.successRate, row.targetRate) === 'on-target';
                  <glxy-badge class="job-standing" [color]="onTarget ? 'green' : 'red'" size="small">
                    @if (onTarget) {
                      {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.ON_TARGET' | translate }}
                    } @else {
                      {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.BELOW_TARGET' | translate }}
                    }
                  </glxy-badge>
                }
              </div>
            </mat-card-content>
          </mat-card>
        </button>
      }
      @if (hiddenCount() > 0) {
        <button type="button" mat-stroked-button class="show-more" (click)="showMore()">
          {{ 'AI_ASSISTANT.SHARED.SHOW_MORE' | translate }}
        </button>
      }
    </div>
  }
}
